import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { api } from "../utils/api";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import { useNavigate } from "react-router-dom";
import smallLogo from "../media/small_logo.svg";
registerLocale("ru", ru);

const scopeMeta = {
  all: {
    label: "Открытая раздача",
    icon: "bi-broadcast-pin",
    tagline: "Кто угодно может забрать",
  },
  me: {
    label: "Лично вам",
    icon: "bi-person-heart",
    tagline: "Только вы видите предложение",
  },
  my: {
    label: "Мое предложение",
    icon: "bi-rocket-takeoff",
    tagline: "Вы разместили это блюдо",
  },
};

const Exchanges = () => {
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [meals, setMeals] = useState([]);
  const [dateWhen, setDateWhen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [exhangeToAccept, setExchangeToAccept] = useState(null);
  const [activeScope, setActiveScope] = useState("all");

  const navigator = useNavigate();

  const loadExchanges = () =>
    Promise.all([api.getExchanges(), api.getMeals({ p: 1, s: 100000 })])
      .then(([exhanges, mealsResponse]) => {
        setData(exhanges);
        setUsers(exhanges.users);
        setMeals(mealsResponse.meals);
      })
      .catch((err) => err.status === 403 && navigator("/access_denied"));

  useEffect(() => {
    loadExchanges();
  }, []);

  const closePopup = () => {
    setExchangeToAccept(null);
    setDateWhen(null);
    setIsLoading(false);
  };

  const acceptExchange = () => {
    if (!exhangeToAccept) return;
    setIsLoading(true);
    api
      .confirmeExchange({ exchangeId: exhangeToAccept, date: dateWhen })
      .then(() => loadExchanges())
      .catch((err) => console.log(err))
      .finally(() => closePopup());
  };

  const denyExchange = (id) => {
    setIsLoading(true);
    api
      .denyExchange({ exchangeId: id })
      .then(() => loadExchanges())
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const totals = {
    all: data?.exchangesForAll?.length || 0,
    me: data?.exchangesForU?.length || 0,
    my: data?.mine?.length || 0,
  };

  const totalOffers = totals.all + totals.me + totals.my;

  const sections = [
    {
      key: "all",
      title: "Открытые обмены",
      description: "Свободные блюда, которые видит вся команда",
      icon: "bi-broadcast",
      items: data?.exchangesForAll || [],
    },
    {
      key: "me",
      title: "Для вас",
      description: "Персональные приглашения только вам",
      icon: "bi-person-check",
      items: data?.exchangesForU || [],
    },
    {
      key: "my",
      title: "Мои предложения",
      description: "Что вы выставили на аукцион",
      icon: "bi-send-check",
      items: data?.mine || [],
    },
  ];

  const currentSection =
    sections.find((section) => section.key === activeScope) || sections[0];

  const renderCard = (item, scope) => {
    const mealData = meals.find((el) => el._id === item.meal.mealId);
    const image = mealData?.image || smallLogo;
    const userFromName =
      users && users.find((el) => el._id === item.userFrom)
        ? users.find((el) => el._id === item.userFrom).name
        : item.userFrom;
    const scopeLabel = scopeMeta[scope]?.label || "Обмен";
    const scopeIcon = scopeMeta[scope]?.icon || "bi-arrow-repeat";
    const tagline = scopeMeta[scope]?.tagline;

    return (
      <div key={item._id} className="auction-card glass-panel">
        <div className="auction-card__accent" aria-hidden="true" />
        <div className="auction-thumb">
          <img src={image} alt={item.meal.name} />
        </div>
        <div className="auction-card__content">
          <div className="auction-card__header">
            <div className={`auction-chip tone-${scope}`}>
              <i className={`bi ${scopeIcon}`} />
              {scopeLabel}
            </div>
            <span className="auction-amount">
              <i className="bi bi-box2-heart" />
              {item.meal.amount} шт.
            </span>
          </div>
          <h3 className="auction-title">{item.meal.name}</h3>
          {mealData?.subName ? (
            <p className="auction-subtitle m-0">{mealData.subName}</p>
          ) : (
            ""
          )}
          {tagline ? <p className="auction-tagline m-0">{tagline}</p> : ""}
          <div className="auction-meta">
            <div className="auction-meta__item">
              <span className="auction-meta__label">Отдает</span>
              <span className="auction-meta__value">{userFromName}</span>
            </div>
          </div>
        </div>
        <div className="auction-card__actions">
          {scope === "my" ? (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => denyExchange(item._id)}
              disabled={isLoading}
            >
              Оставить себе
            </Button>
          ) : (
            <>
              {scope === "me" ? (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => denyExchange(item._id)}
                  disabled={isLoading}
                >
                  Отклонить
                </Button>
              ) : (
                ""
              )}
              <Button
                variant="primary"
                size="sm"
                onClick={() => setExchangeToAccept(item._id)}
                disabled={isLoading}
              >
                Забрать
              </Button>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="auction-layout">
        <div className="auction-hero glass-panel">
          <div className="auction-hero__main">
            <div className="chip accent-chip">
              <i className="bi bi-arrow-repeat" />
              Аукцион обменов
            </div>
            <h1 className="fw-bold mb-1">Свежие блюда, которые можно забрать</h1>
          </div>
          <div className="auction-hero__stats">
            <div className="auction-stat">
              <div className="auction-stat__icon">
                <i className="bi bi-broadcast" />
              </div>
              <div>
                <p className="auction-stat__label">Открытых</p>
                <p className="auction-stat__value">{totals.all}</p>
              </div>
            </div>
            <div className="auction-stat">
              <div className="auction-stat__icon soft">
                <i className="bi bi-person-check" />
              </div>
              <div>
                <p className="auction-stat__label">Для вас</p>
                <p className="auction-stat__value">{totals.me}</p>
              </div>
            </div>
            <div className="auction-stat">
              <div className="auction-stat__icon warning">
                <i className="bi bi-send-check" />
              </div>
              <div>
                <p className="auction-stat__label">Ваши</p>
                <p className="auction-stat__value">{totals.my}</p>
              </div>
            </div>
            <div className="auction-stat">
              <div className="auction-stat__icon neutral">
                <i className="bi bi-grid-3x3-gap" />
              </div>
              <div>
                <p className="auction-stat__label">Всего позиций</p>
                <p className="auction-stat__value">{totalOffers}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="auction-tabs glass-panel">
          {sections.map((section) => (
            <button
              type="button"
              key={section.key}
              className={`auction-tab${activeScope === section.key ? " is-active" : ""}`}
              onClick={() => setActiveScope(section.key)}
            >
              <div className="auction-tab__top">
                <span className="auction-tab__icon">
                  <i className={`bi ${section.icon}`} />
                </span>
                <span className="auction-tab__count">{section.items.length}</span>
              </div>
              <span className="auction-tab__label">{section.title}</span>
              <span className="auction-tab__hint">{section.description}</span>
            </button>
          ))}
        </div>

        <div className="auction-section glass-panel">
          <div className="auction-section__head">
            <div>
              <p className="chip muted-chip mb-2">
                <i className="bi bi-eye" />
                {currentSection.title}
              </p>
              <h4 className="m-0">{currentSection.description}</h4>
            </div>
            <div className="auction-section__meta">
              <span className="auction-pill">
                <i className="bi bi-circle-fill" />
                {currentSection.items.length} в подборке
              </span>
              <span className="auction-pill subtle">
                <i className="bi bi-collection-play" />
                Всего на аукционе: {totalOffers}
              </span>
            </div>
          </div>

          {currentSection.items.length ? (
            <div className="auction-cards">
              {currentSection.items.map((meal) => renderCard(meal, currentSection.key))}
            </div>
          ) : (
            <div className="auction-empty">
              <div className="auction-empty__icon">
                <i className="bi bi-emoji-neutral" />
              </div>
              <p className="fw-semibold mb-1">Пока нет предложений</p>
              <p className="text-muted mb-0">
                Переключитесь на другую вкладку или предложите свое блюдо в разделе &laquo;Мои
                предложения&raquo;.
              </p>
            </div>
          )}
        </div>
      </div>

      <Modal show={!!exhangeToAccept} onHide={closePopup}>
        <Modal.Header closeButton>
          <Modal.Title>Забрать блюдо</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Когда забрать/съесть?</Form.Label>
              <DatePicker
                selected={dateWhen}
                className="form-control"
                locale="ru"
                dateFormat="dd.MM.yyyy"
                onChange={(e) => setDateWhen(e)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closePopup} disabled={isLoading}>
            Закрыть
          </Button>
          <Button
            variant="primary"
            onClick={acceptExchange}
            disabled={isLoading}
          >
            {isLoading ? "Идем договариваться..." : "Подтвердить"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Exchanges;
